import { trackEvent } from "@/utils/analytics";

export const trackPartnerNetworkPageViewed = (): void => {
  trackEvent("partner_network.page_viewed", {
    category: "Partner Network",
    action: "page_viewed",
  });
};

interface PartnerCardClickParams {
  resourceType: string;
  resourceUuid: string;
}

export const trackPartnerCardClick = (params: PartnerCardClickParams): void => {
  trackEvent("partner_network.partner_card_clicked", {
    category: "Partner Discovery",
    action: "partner_card_clicked",
    resource_type: params.resourceType,
    resource_uuid: params.resourceUuid,
  });
};

interface PartnerDetailsViewParams {
  resourceType: string;
  resourceUuid: string;
}

export const trackPartnerDetailsView = (
  params: PartnerDetailsViewParams,
): void => {
  trackEvent("partner_network.partner_details_viewed", {
    category: "Partner Details",
    action: "partner_details_viewed",
    resource_type: params.resourceType,
    resource_uuid: params.resourceUuid,
  });
};

export const trackPartnerNetworkFiltersChanged = (): void => {
  trackEvent("partner_network.filters_changed", {
    category: "Partner Network Filters",
    action: "filters_changed",
  });
};
